<template>
  <v-card class="pa-4">
    <v-flex xs12 pb-4 v-if="err">
      <v-alert :value="true" type="error">{{err}}</v-alert>
    </v-flex>
    <v-form v-model="valid">
      <v-layout row wrap align-end class="py-1 px-2">    
        <v-flex xs12 sm6 px-3>
          <v-select
            :items="years"
            :label="$lang.actions.selectYear"
            v-model="year"
            required
            :rules="[v => !!v || `${$lang.errors.missingYear}`]"
          />
        </v-flex>
        <v-flex xs12 sm6 px-3>
          <v-select
            :items="months"
            :label="$lang.actions.selectMonth"
            v-model="month"
            :rules="[v => !!v || `${$lang.errors.missingMonth}`]"
          />
        </v-flex>
      </v-layout>
      <v-btn color="primary" :loading="loading" :disabled="!valid" class="mb-2 mt-0 mx-4" @click="buildInvoice()">{{$lang.labels.generate}}</v-btn>
    </v-form>
  </v-card>
</template>

<script>
  import { DateTime } from 'luxon';

  export default {
    props: ['months', 'years', 'selectedMonth', 'selectedYear'],
    data() {
      return {
        err: '',
        success: '',
        month: this.selectedMonth || null,
        year: this.selectedYear || null,
        valid: false,
        loading: false,
      };
    },
    methods: {
      async buildInvoice() {
        this.err = '';
        this.loading = true;
        this.$http.post('pricinggroupinvoice/generateinvoice', {
          month: this.month,
          year: this.year,
        })
        .then((res) => {
          this.loading = false;
          if (res.body.status === 'Success') {
            this.$emit('close');
            return;
          }
          this.err = `Failed to generate invoice`;
        }, (err) => {
          this.loading = false;
          this.err = `Failed to generate invoice`;
        });
      },
    },
  }
</script>


// WEBPACK FOOTER //
// InvoiceGenerateModal.vue?7eda3325